<!--<router-outlet>-->
  <!--<div [class]="brandingTheme" style="position: relative; height: 100%">-->
  <div [class]="brandingTheme" style="height: 100%;">
    <div *ngIf="['messenger','squash','liqpay_checkout','trainers_widget','sms_login'].includes(state)"
         [class.fake-mobile-container]="!layoutMatches.isHandsetDefaultLayout">
      <app-mobile-container></app-mobile-container>
    </div>
<!--    <div *ngIf="['trainers_widget'].includes(state)">-->
<!--      <app-trainers-widget></app-trainers-widget>-->
<!--    </div>-->
    <!-- admin panel -->
    <mat-drawer-container *ngIf="!['messenger','squash','liqpay_checkout','trainers_widget','sms_login'].includes(state)" class="example-container" [hasBackdrop]="true">
      <mat-drawer #drawer [mode]="'over'">
        <app-left-menu [application]="this"></app-left-menu>
      </mat-drawer>
      <mat-drawer-content>
        <div class="app-wrapper">
          <app-not-found-page *ngIf="['error','recipes','workouts'].includes(state)" (back)="router.navigateByUrl('/articles')" [application]="this">
          </app-not-found-page>
          <app-login-form *ngIf="(['login','sms_login'].includes(state) && account)" [application]="this"></app-login-form>
          <app-mfa-form
            *ngIf="((state=='setup_mfa_ga' || state=='setup_mfa_sms' || state=='enter_mfa_ga' || state=='enter_mfa_sms') && account)">
          </app-mfa-form>

          <app-profile-password-reset *ngIf="(state === 'password_reset' && account)"></app-profile-password-reset>
          <app-profile-password-change *ngIf="(state === 'password_change' && account)" [application]="this" ></app-profile-password-change>

          <app-article-view-container
            style="width: 100%; height: 100%"
            *ngIf="state=='static_article' && account" [account]="account" [application]="this"></app-article-view-container>

          <div *ngIf="['clients','big_calendar','referrals','reports','articles_folders','articles','article_item','article_item_edit'].includes(state) && user.id"
            class="app-content">
            <div class="top-toolbars-wrapper">
              <!-- toolbars-wrapper -->
              <mat-toolbar id="primary_toolbar" class="header-toolbar center75">
                <button mat-icon-button (click)="drawer.toggle()" color="accent" class="menu-button">
                  <mat-icon>menu</mat-icon>
                </button>
                <img *ngIf="account && account.logo" src="{{account.logo}}" [routerLink]="['/']" class="account-logo"
                     alt="Account logo" (click)="handleGoHome()">
                <div class="fs-navigation">
                  <div class="switcher">
                    <a [routerLink]="['/files']" routerLinkActive="router-zero-active" *ngIf="user.admin && user.snapshots_available">Files</a>
                    <a [routerLink]="['/snapshots']" routerLinkActive="router-zero-active" *ngIf="user.admin && user.snapshots_available">Snapshots</a>
                  </div>
                  <div class="flex" style="align-items: center;">
                    <div *ngIf="isFilterAllowed && ['clients'].includes(state)" class="filter-box hidden-xs">
                      <mat-icon color="accent">
                        filter_list
                      </mat-icon>
                      <input placeholder="phohe/name" id="filterInput"
                             [(ngModel)]="filterValue" (keyup.escape)="onSearchClear()"
                         (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" />
                      <mat-icon *ngIf="filterValue" class="cancel-filter" (click)="onSearchClear()" alt="Clear Filter">
                        cancel
                      </mat-icon>
                    </div>
                    <div class="fs-navigation-btn flex" style="align-items: center;">
                      <!--<div class="username-wrapper hidden-xs" [matTooltip]="user.name">{{user.name}}</div>-->
                      <!--<mat-icon class="hidden visible-xs">account_circle</mat-icon>-->
                      <!--<mat-icon class="cursor" [matTooltip]="'Logout'" (click)="handleLogout()">exit_to_app</mat-icon>-->

                      <button mat-icon-button
                              class="account-circle"
                              [matMenuTriggerFor]="toolbarUserMenu" [matTooltip]="'Logged as ' + user.shipping_name"
                              (menuOpened)="setUserMenuOpened(true)"
                              (menuClosed)="setUserMenuOpened(false)">
                        <mat-icon class="icon-color bigger-icon">account_circle</mat-icon>
                        <mat-icon class="icon-color" *ngIf="!userMenuOpened">arrow_drop_down</mat-icon>
                        <mat-icon class="icon-color" *ngIf="userMenuOpened">arrow_drop_up</mat-icon>
                      </button>

                      <!--<mat-icon class="account-circle icon-color">account_circle</mat-icon>-->
                      <!--<mat-icon class="icon-color cursor" [matMenuTriggerFor]="toolbarUserMenu">arrow_drop_down</mat-icon>-->
                      <mat-menu #toolbarUserMenu="matMenu" xPosition="before" class="toolbar-user-menu">
                        <app-user-menu [userMenuOpened]="userMenuOpened"></app-user-menu>
                      </mat-menu>
                    </div>
                  </div>
                </div>
              </mat-toolbar>

              <div id="big_top_toolbar" class="big-toolbar-top center75">
                <div class="toolbar-navigation">
                  <ng-container *ngIf="navigationPath.length">
                    <button mat-icon-button routerLink="{{navigationPath[0]['route']}}"
                            color="accent" class="home-button">
                      <mat-icon>home</mat-icon>
                    </button>
                    <div class="toolbar-path">
                      <div *ngFor="let el of navigationPath.slice(1);" class="path-item"
                           [matTooltip]="el.label">
                        <mat-icon class="path-separator">keyboard_arrow_right</mat-icon>
                        <a class="ellipsis" title="{{el.label}}"
                           routerLink="{{el.route}}">
                          {{ el.label }}
                        </a>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Deprecated -->
<!--                  <button *ngIf="false" mat-icon-button (click)="handleGoHome()" color="accent" class="home-button">-->
<!--                    <mat-icon>home</mat-icon>-->
<!--                  </button>-->
<!--                  <div *ngIf="splitedPath.length && folderExist" class="toolbar-path">-->
<!--                    <div class="path-item">-->
<!--                      <mat-icon class="path-separator">keyboard_arrow_right</mat-icon>-->
<!--                      <a class="ellipsis" title="{{splitedPath[0].path}}"-->
<!--                        routerLink="/{{state}}/{{splitedPath | fsGetUrlPartByIdx : 0}}">-->
<!--                        {{ splitedPath[0].path }}-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div *ngIf="splitedPath.length > 3" class="path-item cursor" [matMenuTriggerFor]="fullPathMenu">-->
<!--                      <mat-icon class="path-separator">keyboard_arrow_right</mat-icon>-->
<!--                      <mat-icon>more_horiz</mat-icon>-->
<!--                    </div>-->
<!--                    <div *ngFor="let el of splitedPath.slice(1).slice(splitedPath.length-3);" class="path-item"-->
<!--                      [matTooltip]="el.path">-->
<!--                      <mat-icon class="path-separator">keyboard_arrow_right</mat-icon>-->
<!--                      <a class="ellipsis" title="{{el.path}}"-->
<!--                        routerLink="/{{state}}/{{splitedPath | fsGetUrlPartByIdx :el.originalIndex}}">-->
<!--                        {{ el.path }}-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->

                </div>
                <mat-menu #fullPathMenu="matMenu">
                  <button *ngFor="let el of splitedPath.slice(1, splitedPath.length - 2)" mat-menu-item [matTooltip]="el.path"
                  routerLink="/{{state}}/{{splitedPath | fsGetUrlPartByIdx :el.originalIndex}}" class="path-link">
                    <mat-icon color="accent">folder</mat-icon>
                     {{el.path}}
                  </button>
                </mat-menu>

                <!-- search box for mobile -->
                <div *ngIf="isFilterAllowed && isHandset && ['clients'].includes(state)" class="filter-box">
                  <mat-icon color="accent">
                    filter_list
                  </mat-icon>
                  <input placeholder="phohe/name"
                         [(ngModel)]="filterValue" (keyup.escape)="onSearchClear()"
                         (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" />
                  <mat-icon *ngIf="filterValue" class="cancel-filter" (click)="onSearchClear()" alt="Clear Filter">
                    cancel
                  </mat-icon>
                </div>

                <div *ngIf="(folderExist && listingComponent) || ['big_calendar','articles_folders','articles','article_item','article_item_edit'].includes(state)"
                     class="toobar-buttons">
<!--                  <button mat-icon-button class="icon-color" (click)="listingComponent.handlePaste()"-->
<!--                    *ngIf="state ==='files' && (listingComponent.listing.copyBuffer.length || listingComponent.listing.moveBuffer.length)">-->
<!--                    <mat-icon>content_paste</mat-icon>-->
<!--                    <div class="mini-gauge">-->
<!--                      {{listingComponent.listing.copyBuffer.length + listingComponent.listing.moveBuffer.length}}-->
<!--                    </div>-->
<!--                  </button>-->
<!--                  <button mat-icon-button class="icon-color" (click)="listingComponent.handleRestore(listingComponent.currentPath)"-->
<!--                    *ngIf="state ==='files' && listingComponent.listing.restoreBuffer.length"-->
<!--                    matTooltip="Restore files from snapshot in this folder.">-->
<!--                    <mat-icon>move_to_inbox</mat-icon>-->
<!--                    <div class="mini-gauge">-->
<!--                      {{listingComponent.listing.restoreBuffer.length}}-->
<!--                    </div>-->
<!--                  </button>-->
<!--                  <button mat-icon-button class="icon-color" (click)="router.navigateByUrl('/files')"-->
<!--                    *ngIf="state=='snapshots' && listingComponent.listing.restoreBuffer.length"-->
<!--                    matTooltip="Go to files and choose folder for files restore.">-->
<!--                    <mat-icon>arrow_back</mat-icon>-->
<!--                    <div class="mini-gauge">-->
<!--                      {{listingComponent.listing.restoreBuffer.length}}-->
<!--                    </div>-->
<!--                  </button>-->
                  <button mat-button class="toolbar-top-btn new-folder-btn hidden-xs"
                    *ngIf="false && state ==='clients'" (click)="openMkDirDialog()">
                    <mat-icon>add</mat-icon>
                    <div style="display: inline; margin-left: 10px">Invite new user</div>
                  </button>
                  <button mat-button class="toolbar-top-btn new-folder-btn hidden-xs"
                    *ngIf="state ==='big_calendar' && !bigCalendarCombinedView" (click)="createBasicEvent()"
                    [disabled]="bigCalendarCombinedView">
                    <mat-icon>add</mat-icon>
                    <div style="display: inline; margin-left: 10px">Створити недоступність</div>
                  </button>
                  <button mat-button class="toolbar-top-btn new-folder-btn"
                          *ngIf="state ==='articles_folders' && isTrainerLogin()" (click)="openNewCourseDialog()">
                    <mat-icon>add</mat-icon>
                    <div style="display: inline; margin-left: 10px">Create new course</div>
                  </button>
                  <button mat-button class="toolbar-top-btn new-folder-btn"
                          *ngIf="state ==='articles' && isTrainerLogin()" (click)="newArticleCategory()">
                    <mat-icon>add</mat-icon>
                    <div style="display: inline; margin-left: 10px">New category</div>
                  </button>
                  <button mat-button class="toolbar-top-btn toolbar-top-btn-warn new-folder-btn"
                          *ngIf="state ==='articles' && folderOwner" (click)="deleteCourse()">
                    <mat-icon color="warn">delete</mat-icon>
                    <div style="display: inline; margin-left: 10px">Delete course</div>
                  </button>

                  <button mat-button class="toolbar-top-btn new-folder-btn"
                          *ngIf="state === 'article_item' && isTrainerLogin()"
                          (click)="editArticleItem()">
                    <mat-icon>edit</mat-icon>
                    <div style="display: inline; margin-left: 10px">Edit article</div>
                  </button>
                  <button mat-button class="toolbar-top-btn new-folder-btn"
                          [disabled]="!dirtyArticleEdit"
                          [class.toolbar-top-btn-disabled]="!dirtyArticleEdit"
                          *ngIf="state === 'article_item_edit' && isTrainerLogin()"
                          (click)="saveArticleItem()">
                    <mat-icon>save</mat-icon>
                    <div style="display: inline; margin-left: 10px">Save article</div>
                  </button>

                  <app-upload-button *ngIf="state === 'files' && user.web_upload"
                    (openUpload)="openUploadDialog()">
                  </app-upload-button>
                </div>
              </div>
            </div>

            <ng-container *ngIf="'reports' == state">
              <div class="listing-container">
                <div class="center75" style="height: 100%;">
                  <iframe src="/panelzf/adminslog" style="width: 100%; height: 100%; border: 1px solid #e0e0e0;"></iframe>
                </div>
              </div>
            </ng-container>

            <app-listing *ngIf="['clients','articles_folders','articles'].includes(state)" [state]="state"
              [filterValue]="filterValue" [userPermissions]="user" (upload)="openUploadDialog()" (back)="handleGoHome()"
              (logout)="handleLogout($event)" (doesFolderExist)="handleFolderStatus($event)" (clearFilter)="onSearchClear()"
              (allowFilter)="handleAllowFilter($event)">
            </app-listing>

            <app-big-calendar-container *ngIf="['big_calendar'].includes(state)"> </app-big-calendar-container>

            <div *ngIf="['referrals'].includes(state)">referrals listing todo</div>

            <app-article-view *ngIf="['article_item','article_item_edit'].includes(state)"></app-article-view>
          </div>
          <app-notification-container></app-notification-container>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
<!--</router-outlet>-->
